(function () {
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-drop-hint-copy]');
    if (!el) return;
    e.preventDefault();
    var url = window.location.href;
    var cap = el.querySelector('.drop-hint-modal__caption');
    function done() {
      if (!cap) return;
      if (!cap.getAttribute('data-original-caption')) {
        cap.setAttribute('data-original-caption', cap.textContent);
      }
      var orig = cap.getAttribute('data-original-caption');
      cap.textContent = 'Copied!';
      window.setTimeout(function () {
        cap.textContent = orig;
      }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () {
        fallback();
      });
      return;
    }
    fallback();
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        if (document.execCommand('copy')) done();
      } catch (err) {}
      document.body.removeChild(ta);
    }
  });
})();
